import { useEffect, useMemo, useState } from "react"
import { CommonConstant, ErrorConstant, PaginationType, UsersService } from "utility"

// export const GetMyDetails = () => {
//     const [{ accounts,loginState }] = useStore()
//     const [data,setData] = useState(null)
//     const [loading,setLoading] = useState(false)
//     const [error,setError] = useState('')

//     useEffect(() => {
//         const fetchData = async () => {
//             try {
//                 setLoading(true)
//                 const result = await UserService.me()
//                 setData(result || {})
//             } catch {
//                 setError(ErrorConstant.default)
//             } finally {
//                 setLoading(false)
//             }
//         }

//         if ((accounts || []).length > 0 && loginState === LoginState.success) {
//             fetchData()
//         }
//     },[accounts,loginState])

//     return {
//         data,
//         loading,
//         error,
//         setData,
//     }
// }

export const GetUserList = () => {
    const [data, setData] = useState([])
    const [loading, setLoading] = useState(false)
    const [error, setError] = useState('')

    const options = useMemo(() => data.map(ele => ({ text: ele.UserName, value: ele.UserId })), [data])

    useEffect(() => {
        const fetchData = async () => {
            try {
                setLoading(true)
                const result = await UsersService.getUsers()
                setData(result || {})
            } catch {
                setError(ErrorConstant.default)
            } finally {
                setLoading(false)
            }
        }
        fetchData()
    }, [])

    return {
        data,
        options,
        loading,
        error,
        setData,
    }
}

export const GetUserListForGroup = (paginationType = PaginationType.default) => {
    const [data, setData] = useState([])
    const [loading, setLoading] = useState(false)
    const [error, setError] = useState('')
    const [filter, setFilter] = useState({
        PageNumber: 1,
        PageSize: CommonConstant.defaultPageSize,
        SearchText: '',
        all: paginationType,
    })

    const options = useMemo(() => data.map(ele => ({ text: ele.Name, value: ele.unique_id })), [data])

    useEffect(() => {
        const fetchData = async () => {
            try {
                setLoading(true)
                const result = await UsersService.getTeamUsers(!filter.all ? filter : { ...filter, PageSize: 5000000 })
                setData(result || {})
            } catch {
                setError(ErrorConstant.default)
            } finally {
                setLoading(false)
            }
        }
        fetchData()
    }, [filter])

    const pageChanged = (page) => {
        setFilter({
            ...filter,
            PageNumber: page,
        })
    }

    const refresh = () => {
        setFilter({
            ...filter,
        })
    }

    return {
        data,
        options,
        loading,
        error,
        setData,
        pageChanged,
        refresh,
    }
}

export const GetTeamMemberList = (paginationType = PaginationType.default) => {
    const [data, setData] = useState([])
    const [loading, setLoading] = useState(false)
    const [error, setError] = useState('')
    const [totalCount, setTotalCount] = useState(0)
    const [filter, setFilter] = useState({
        PageNumber: 1,
        PageSize: CommonConstant.defaultPageSize,
        all: paginationType,
    })

    useEffect(() => {
        const fetchData = async () => {
            try {
                setLoading(true)
                const result = await UsersService.getTeamUsers(
                    !filter.all ? filter : { ...filter, PageSize: 5000000 },
                )
                // Handle both array response and paginated response
                if (Array.isArray(result)) {
                    setData(result)
                    setTotalCount(result.length)
                } else if (result?.Items) {
                    setData(result.Items)
                    setTotalCount(result.TotalCount || result.Items.length)
                } else {
                    setData([])
                    setTotalCount(0)
                }
            } catch {
                setError(ErrorConstant.default)
                setData([])
                setTotalCount(0)
            } finally {
                setLoading(false)
            }
        }
        fetchData()
    }, [filter])

    const pageChanged = (page) => {
        setFilter({
            ...filter,
            PageNumber: page,
        })
    }

    const refresh = () => {
        setFilter({
            ...filter,
        })
    }

    return {
        data,
        setData,
        loading,
        error,
        filter,
        totalCount,
        pageChanged,
        refresh,
    }
}

// export const GetUserDetailsByAddress = address => {
//     const [data,setData] = useState(null)
//     const [loading,setLoading] = useState(false)
//     const [error,setError] = useState('')

//     useEffect(() => {
//         const fetchData = async () => {
//             try {
//                 setLoading(true)
//                 const result = await UserService.byAddress(address)
//                 setData(result || {})
//             } catch {
//                 setError(ErrorConstant.default)
//             } finally {
//                 setLoading(false)
//             }
//         }

//         if (address) {
//             fetchData()
//         }
//     },[address])

//     return {
//         data,
//         loading,
//         error,
//     }
// }

// export const GetUserDetailsByAddresses = addresses => {
//     const [data,setData] = useState({})
//     const [loading,setLoading] = useState(false)
//     const [error,setError] = useState('')

//     useEffect(() => {
//         const fetchData = async () => {
//             try {
//                 setLoading(true)
//                 const result = await UserService.byAddresses(addresses)
//                 setData(result)
//             } catch {
//                 setError(ErrorConstant.default)
//             } finally {
//                 setLoading(false)
//             }
//         }

//         if (addresses.length > 0) {
//             fetchData()
//         }
//     },[addresses])

//     return {
//         data,
//         loading,
//         error,
//     }
// }
